<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Budget Tracker Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedCinema.cine_id ? 'shift-up' : ''">
                  {{ "Select Cinema" }}
                </label>

                <multiselect
                  v-model="selectedCinema"
                  placeholder=""
                  @select="onSelectCinema"
                  :options="dropDown.cinemas"
                  label="cine_name"
                  track-by="cine_id"
                  :multiple="false"
                  name="cine_id"
                  id="cine_id"
                  deselect-label="Remove"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <multiselect
                  :options="yearArr"
                  v-model="selectedYear"
                  :searchable="false"
                  label="year"
                  track-by="year_id"
                  placeholder="Select Year"
                  @input="onSelectYear($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
                <label :class="selectedYear.year_id != null ? 'active' : ''">
                  Select Year
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="fetchData()">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
          <div class="col-lg-6 col-xl-3 mb-3">
            <div
              class="d-flex justify-content-end mt-5 align-items-center"
              v-if="budgetArray.length"
            >
              <div>{{ $t("download") }} as:</div>
              <a href="#" @click="excelDownload()" title="Download as Excel">
                <img
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey">
            <th>{{ selectedYear.year || "Selected Year" }}</th>
            <th>Admits</th>
            <th>Admit Budget</th>
            <th>%</th>
            <th>BO Rev</th>
            <th>OCCU %</th>
            <th>ATP</th>
            <th>ATP Budget</th>
            <th>%</th>
            <th>CON Rev</th>
            <th>SPH</th>
            <th>SPH Budget</th>
            <th>%</th>
            <th>SR%</th>
            <th>CC Sales</th>
            <th>Total Revenue</th>
          </thead>
          <tbody>
            <template v-if="budgetArray.length">
              <tr v-for="(item, index) in budgetArray" :key="index">
                <td>{{ item.month }}</td>
                <td class="text-right">{{ item.admits || "-" }}</td>
                <td class="text-right">
                  {{
                    item.admit_budget
                      ? currFormat(parseFloat(item.admit_budget))
                      : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    item.admit_percentage
                      ? currFormat(parseFloat(item.admit_percentage))
                      : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    item.box_office_revenue
                      ? currFormat(parseFloat(item.box_office_revenue))
                      : "-"
                  }}
                </td>
                <td class="text-right">
                  {{ item.occupacy ? currFormat(item.occupacy) : "-" }}
                </td>
                <td class="text-right">
                  {{
                    item.atp_budget_sys ? currFormat(item.atp_budget_sys) : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    item.atp_budget
                      ? currFormat(parseFloat(item.atp_budget))
                      : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    item.atp_percentage ? currFormat(item.atp_percentage) : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    item.concession_received
                      ? currFormat(item.concession_received)
                      : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    item.sph_value_sys ? currFormat(item.sph_value_sys) : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    item.sph_budget
                      ? currFormat(parseFloat(item.sph_budget))
                      : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    item.sph_percentage ? currFormat(item.sph_percentage) : "-"
                  }}
                </td>
                <td class="text-right">
                  {{ item.strike_rate ? currFormat(item.strike_rate) : "-" }}
                </td>
                <td class="text-right">
                  {{ item.cc_sales ? currFormat(item.cc_sales) : "-" }}
                </td>
                <td class="text-right">
                  {{
                    item.total_revenue ? currFormat(item.total_revenue) : "-"
                  }}
                </td>
              </tr>
            </template>
            <td colspan="16" v-if="budgetArray.length == 0">
              <NoRecords />
            </td>
          </tbody>
          <thead class="bg-lightgrey" v-if="budgetArray.length > 0">
            <th>Grand Total</th>
            <th class="text-right">{{ grand_total.admits || "-" }}</th>
            <th class="text-right">
              {{
                grand_total.admit_budget
                  ? currFormat(parseFloat(grand_total.admit_budget))
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.admit_budget && grand_total.admits
                  ? currFormat(
                      parseFloat(
                        (grand_total.admits * 100) /
                          parseFloat(grand_total.admit_budget)
                      )
                    )
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.box_office_revenue
                  ? currFormat(parseFloat(grand_total.box_office_revenue))
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.total_admits && grand_total.admits
                  ? currFormat(
                      parseFloat(
                        (grand_total.admits * 100) /
                          parseFloat(grand_total.total_admits)
                      )
                    )
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.box_office_revenue && grand_total.admits
                  ? currFormat(
                      parseFloat(
                        grand_total.box_office_revenue /
                          parseFloat(grand_total.admits)
                      )
                    )
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.atp_budget
                  ? currFormat(parseFloat(grand_total.atp_budget))
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.box_office_revenue &&
                grand_total.admits &&
                grand_total.atp_budget
                  ? currFormat(
                      parseFloat(
                        (parseFloat(
                          grand_total.box_office_revenue /
                            parseFloat(grand_total.admits)
                        ) *
                          100) /
                          parseFloat(grand_total.atp_budget)
                      )
                    )
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.concession_received
                  ? currFormat(grand_total.concession_received)
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.concession_received && grand_total.admits
                  ? currFormat(
                      parseFloat(
                        grand_total.concession_received /
                          parseFloat(grand_total.admits)
                      )
                    )
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.sph_budget
                  ? currFormat(parseFloat(grand_total.sph_budget))
                  : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.concession_received &&
                grand_total.admits &&
                grand_total.sph_budget
                  ? currFormat(
                      parseFloat(
                        (parseFloat(
                          grand_total.concession_received /
                            parseFloat(grand_total.admits)
                        ) *
                          100) /
                          parseFloat(grand_total.sph_budget)
                      )
                    )
                  : "-"
              }}
            </th>
            <th class="text-right"></th>
            <th class="text-right">
              {{
                grand_total.cc_sales ? currFormat(grand_total.cc_sales) : "-"
              }}
            </th>
            <th class="text-right">
              {{
                grand_total.total_revenue
                  ? currFormat(grand_total.total_revenue)
                  : "-"
              }}
            </th>
          </thead>
        </table>
      </div>
      <!---New-->
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import BudgetService from "@/services/BudgetService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
      },
      selectedCinemaId: [],
      selectedCinema: [],
      selectedYear: {
        year_id: null,
        year: "",
      },
      yearArr: [],
      monthsArr: [],
      budgetArray: [],
      grand_total: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
    this.setYearArr();
    this.setMonthArr();
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  methods: {
    moment,
    excelDownload() {
      let temp_data = [...this.budgetArray];
      let grandTotalObj = {
        month: "Grand Total",
        admits: this.grand_total.admits || "-",
        admit_budget: this.grand_total.admit_budget
          ? +parseFloat(this.grand_total.admit_budget).toFixed(this.MIN_FRACTION_DIGITS)
          : "-",
        admit_percentage:
          this.grand_total.admit_budget && this.grand_total.admits
            ? parseFloat(
                (this.grand_total.admits * 100) /
                  parseFloat(this.grand_total.admit_budget)
              )
            : "-",
        box_office_revenue: this.grand_total.box_office_revenue
          ? parseFloat(this.grand_total.box_office_revenue)
          : "-",
        occupacy:
          this.grand_total.total_admits && this.grand_total.admits
            ? parseFloat(
                (this.grand_total.admits * 100) /
                  parseFloat(this.grand_total.total_admits)
              ).toFixed(this.MIN_FRACTION_DIGITS)
            : "-",
        atp_budget_sys:
          this.grand_total.box_office_revenue && this.grand_total.admits
            ? parseFloat(
                this.grand_total.box_office_revenue /
                  parseFloat(this.grand_total.admits)
              ).toFixed(this.MIN_FRACTION_DIGITS)
            : "-",
        atp_budget: this.grand_total.atp_budget
          ? parseFloat(parseFloat(this.grand_total.atp_budget)).toFixed(this.MIN_FRACTION_DIGITS)
          : "-",
        atp_percentage:
          this.grand_total.box_office_revenue &&
          this.grand_total.admits &&
          this.grand_total.atp_budget
            ? (parseFloat(
                this.grand_total.box_office_revenue /
                  parseFloat(this.grand_total.admits)
              ) *
                100) /
              parseFloat(this.grand_total.atp_budget)
            : "-",
        concession_received: this.grand_total.concession_received
          ? parseFloat(this.grand_total.concession_received).toFixed(this.MIN_FRACTION_DIGITS)
          : "-",
        sph_value_sys:
          this.grand_total.concession_received && this.grand_total.admits
            ? parseFloat(
                parseFloat(
                  this.grand_total.concession_received /
                    parseFloat(this.grand_total.admits)
                )
              ).toFixed(this.MIN_FRACTION_DIGITS)
            : "-",
        sph_budget: this.grand_total.sph_budget
          ? parseFloat(this.grand_total.sph_budget).toFixed(this.MIN_FRACTION_DIGITS)
          : "-",
        sph_percentage:
          this.grand_total.concession_received &&
          this.grand_total.admits &&
          this.grand_total.sph_budget
            ? parseFloat(
                (parseFloat(
                  this.grand_total.concession_received /
                    parseFloat(this.grand_total.admits)
                ) *
                  100) /
                  parseFloat(this.grand_total.sph_budget)
              ).toFixed(this.MIN_FRACTION_DIGITS)
            : "-",
        strike_rate: "",
        cc_sales: this.grand_total.cc_sales
          ? parseFloat(this.grand_total.cc_sales).toFixed(this.MIN_FRACTION_DIGITS)
          : "-",
        total_revenue: this.grand_total.total_revenue
          ? parseFloat(this.grand_total.total_revenue).toFixed(this.MIN_FRACTION_DIGITS)
          : "-",
      };
      temp_data.push(grandTotalObj);
      let data = [
        {
          sheet: "Complimentary Summary",
          columns: [
            {
              value: "month",
              label: "Month",
            },
            {
              value: (row) => row.admits || "-",
              label: "Admits",
            },
            {
              value: (row) =>
                row.admit_budget
                  ? parseFloat(row.admit_budget).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Admit Budget",
            },
            {
              value: (row) =>
                row.admit_percentage
                  ? +parseFloat(row.admit_percentage).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Admit%",
            },
            {
              value: (row) =>
                row.box_office_revenue
                  ? +parseFloat(row.box_office_revenue).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "BO Rev",
            },
            {
              value: (row) =>
                row.occupacy ? +parseFloat(row.occupacy).toFixed(this.MIN_FRACTION_DIGITS) : "-",
              label: "Occu %",
            },
            {
              value: (row) =>
                row.atp_budget_sys
                  ? +parseFloat(row.atp_budget_sys).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Atp",
            },
            {
              value: (row) =>
                row.atp_budget ? +parseFloat(row.atp_budget).toFixed(this.MIN_FRACTION_DIGITS) : "-",
              label: "ATP Budget",
            },
            {
              value: (row) =>
                row.atp_percentage
                  ? +parseFloat(row.atp_percentage).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "ATP%",
            },
            {
              value: (row) =>
                row.concession_received
                  ? +parseFloat(row.concession_received).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "CON Rev",
            },
            {
              value: (row) =>
                row.sph_value_sys
                  ? +parseFloat(row.sph_value_sys).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "SPH",
            },
            {
              value: (row) =>
                row.sph_budget ? +parseFloat(row.sph_budget).toFixed(this.MIN_FRACTION_DIGITS) : "-",
              label: "SPH Budget",
            },
            {
              value: (row) =>
                row.sph_percentage
                  ? +parseFloat(row.sph_percentage).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "SPH%",
            },
            {
              value: (row) =>
                row.strike_rate ? +parseFloat(row.strike_rate).toFixed(this.MIN_FRACTION_DIGITS) : "-",
              label: "SR%",
            },
            {
              value: (row) =>
                row.cc_sales ? +parseFloat(row.cc_sales).toFixed(this.MIN_FRACTION_DIGITS) : "-",
              label: "CC Sales",
            },
            {
              value: (row) =>
                row.total_revenue
                  ? +parseFloat(row.total_revenue).toFixed(this.MIN_FRACTION_DIGITS)
                  : "-",
              label: "Total Revenue",
            },
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `BudgetTrackerReport${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    movieHandler(event, type) {
      console.log(event);
    },
    onSelectYear(event) {
      console.log(event);
    },
    fetchData() {
      if (!this.selectedCinema) {
        this.$toasted.show("Please Select Cinema ");
        return false;
      }
      if (!this.selectedCinema.cine_id) {
        this.$toasted.show("Please Select Cinema ");
        return false;
      }
      if (!this.selectedYear.year) {
        this.$toasted.show("Please Select Year");
        return false;
      }
      let payload = {
        cinema_id: this.selectedCinema.cine_id,
        year: this.selectedYear.year,
      };
      this.budgetArray = [];

      console.log("Data Fetch", payload);
      let loader = this.$loading.show();

      BudgetService.getBudgetReport(payload)
        .then((response) => {
          const { data } = response;
          loader.hide();
          if (data.status && data.budget_array.length > 0) {
            this.budgetArray = data.budget_array;
            this.grand_total = data.grand_total;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    setYearArr() {
      let currentYear = new Date().getFullYear() - 20;
      for (let i = 1; i <= 20; i++) {
        this.yearArr.push({
          year_id: i,
          year: currentYear + i,
        });
      }
      this.yearArr.reverse();
    },
    setMonthArr() {
      for (let i = 0; i <= 11; i++) {
        this.monthsArr.push({
          month_id: moment().startOf("year").add(i, "months").format("MM"),
          month: moment().startOf("year").add(i, "months").format("MMMM"),
          key1: "",
          key2: "",
          key3: "",
        });
      }
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            let array = { ...data.Records[0] };
            array.cine_name = "All Cinema";
            array.cine_id = "all";

            this.dropDown.cinemas.unshift(array);

            this.CinemasCopy = [...[array], ...data.Records];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      if (event.cine_id != "all") {
        this.$store.dispatch("selectDropdownCinema", event);
      }
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/budgetTrackerReport.vue